import { Button as UIButton } from '@jobtarget/ui-library';
import { ReactNode, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import Spinner from './Spinner';

interface IButton {
  text: string | ReactNode;
  variant:
    | 'primary'
    | 'link'
    | 'danger'
    | 'outline-danger'
    | 'outline-primary'
    | 'outline-secondary'
    | 'transparent'
    | undefined;
  onClick?: () => void;
  disabled?: boolean;
  style?: React.CSSProperties;
  'id'?: string;
  showSpinner?: boolean;
}

const Button = ({ text, variant, onClick, style, disabled, 'id': gtmId, showSpinner=true }: IButton) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const handleClick = async () => {
    if (onClick) {
      setIsProcessing(true);
      await new Promise(resolve => setTimeout(resolve, 250));
      onClick();
      setIsProcessing(false);
    }
  };
  
  // Content with spinner for processing state
  const buttonContent = isProcessing ? (
    <>
      <Spinner size="sm" color="light" />
    </>
  ) : text;

  return (
    <div>
      <UIButton 
        variant={variant} 
        onClick={handleClick} 
        style={style}
        disabled={disabled || isProcessing}
        id={gtmId}
      >
        {buttonContent}
      </UIButton>
    </div>
  );
};

export default Button;
